<template>
  <h3>Version 1.0.0</h3>
  <div>
    <a target="_blank" href="https://github.com/fordp86/traversy-vue"
      >View Source on Github</a
    >
  </div>
  <router-link to="/">Go Back</router-link>
</template>
